import moment from 'moment';

import { useContext } from 'react';

import { gql } from '@apollo/client';
 
import { MusicNote } from '@mui/icons-material';

import { useQuery } from '@apollo/client';

import { Breadcrumbs, Link as MaterialLink, Typography, Container, Paper } from '@mui/material';

import { NodeTable } from '@/components/NodeTable';

import i18n from '@/i18n';

import { Link } from '@/components';
import { useSearchParams } from 'react-router-dom';
import { Statistics } from '@/components/Statistics';
import { DiscoveryModeContext } from '@/contexts/DiscoveryModeContext';

const QUERY = gql`
  query {
    spotify {
      discoveryModeCampaigns {
        id
        start
        end
      }
    }
  }
`

export function DiscoveryModeCampaignsPage() {
  const [searchParams, setSearchParams] = useSearchParams()

  const {
    start,
    end,
    selectedOrganizations,
    selectedLabels,
    selectedArtists,
    selectedRecordings,
    breakdown,
    stage
  } = useContext(DiscoveryModeContext)

  return (
    <Container maxWidth="xl">
      <Breadcrumbs aria-label="breadcrumb">
        <Typography>{i18n.t('discovery-mode')}</Typography>
        <MaterialLink as={Link} to={{ pathname: '/dashboard/discovery-mode/campaigns', search: searchParams.toString() }}>{i18n.t('campaigns')}</MaterialLink>
      </Breadcrumbs>
      <Typography>{i18n.t('discovery-mode-stats-for-the-latest-x-months', { numberOfMonths: 6 })}</Typography>
      <Paper>
        <DiscoveryModeCampaignsContainer
          start={start?.format('YYYY-MM-DD')}
          end={end?.format('YYYY-MM-DD')}
          organizationIds={selectedOrganizations?.map(o => o.slug)}
          labelIds={selectedLabels?.map(l => l.slug)}
          artistIds={selectedArtists?.map(a => a.slug)}
        />
      </Paper>
    </Container>
  )
}

export function DiscoveryModeCampaignsContainer({
}) {
  const [searchParams, setSearchParams] = useSearchParams()

  const { data, previousData } = useQuery(QUERY, {
    variables: {}
  })

  const onNodesChecked = () => {}
  const onPerformAction = () => {}

  const spotify = (data ?? previousData)?.spotify
  const discoveryModeCampaigns = spotify?.discoveryModeCampaigns
  return (
    <>
      {discoveryModeCampaigns && (
        <NodeTable
          onNodesChecked={onNodesChecked}
          onPerformAction={onPerformAction}
          canCheck={true}
          renderRowClassNames={({ node }) => {    
            return ''
          }}
          emptyHeading={i18n.t('No campaigns found')}
          emptyText={i18n.t('No campaigns found')}
          emptyIcon={MusicNote}
          isRowUnavailable={(row) => {
            return false        
          }}
          toolbarButtons={() => <></>}
          sx={{
            '& .row-success': {
              bgcolor: 'rgba(0, 255, 0, .1)'
            },
            '& .row-error': {
              bgcolor: 'rgba(255, 0, 0, .1)'
            },
            '& .row-warning': {
              bgcolor: 'rgba(255, 255, 0, .1)'
            }
          }}
          actions={[ 
          ]}
          columns={[
            {
              id: 'name',
              name: i18n.t('name'),
              type: 'name',
              render: ({ node }) => {
                return (
                  <Link to={{ pathname: `/dashboard/discovery-mode/campaign/${node.id}`, search: searchParams.toString()}}>{node.start} - {node.end}</Link>
                )
              }
            }
          ]}
          nodes={discoveryModeCampaigns}
        />
      )}
    </>
  )
  
}

export default DiscoveryModeCampaignsPage;
